import { NavLink } from 'react-router-dom';
import { clsx } from 'clsx';
import { Building2, Bot, FileCheck2, ScrollText, ChevronLeft, ChevronRight } from 'lucide-react';
import styles from './AgencySidebar.module.css';

interface AgencySidebarProps {
  collapsed: boolean;
  onToggle: () => void;
}

/*
 * Four places. Practices is home (one row per practice, with the cross-practice
 * queue as a view of the same page). Agents holds what an agent *is* for every
 * practice — its skills, flow map and overrides; what an agent does for one
 * practice lives on that practice's Agents tab. Agency-wide reference data and
 * the audit trail are their own entries. There is no Settings drawer: the one
 * thing it held (the Meta Ads token) lives with the Ads module it configures.
 */
const MAIN_NAV: Array<{ label: string; path: string; icon: typeof Building2; end: boolean }> = [
  { label: 'Practices', path: '/agency', icon: Building2, end: true },
  { label: 'Agents', path: '/agency/agents', icon: Bot, end: false },
  { label: 'Insurance Payers', path: '/agency/insurance-payers', icon: FileCheck2, end: false },
  { label: 'Audit Log', path: '/agency/audit-log', icon: ScrollText, end: false },
];

export function AgencySidebar({ collapsed, onToggle }: AgencySidebarProps) {
  return (
    <nav className={clsx(styles.sidebar, collapsed && styles.collapsed)}>
      <div className={styles.header}>
        {!collapsed && (
          <div className={styles.logo}>
            <span className={styles.logoText}>PracticeNova</span>
          </div>
        )}
        <button className={styles.toggleBtn} onClick={onToggle} aria-label="Toggle sidebar">
          {collapsed ? <ChevronRight size={16} /> : <ChevronLeft size={16} />}
        </button>
      </div>

      <div className={styles.nav}>
        <div className={styles.navMain}>
          {MAIN_NAV.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.end}
                className={({ isActive }) => clsx(styles.navItem, isActive && styles.navItemActive)}
                title={collapsed ? item.label : undefined}
              >
                <Icon size={16} className={styles.navIcon} />
                {!collapsed && <span className={styles.navLabel}>{item.label}</span>}
              </NavLink>
            );
          })}
        </div>
      </div>
    </nav>
  );
}
